import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "../../../pageComponents/Settings/Free/Button";
import BlackButton from "./BlackButton";

class Ad extends React.Component{
    constructor() {
        super();
    }
    render() {
        const {bottomFontSize,buttonTextColor,title,price,adIcon,adText,text,buttonText,buttonBackgroundColor,borderColor,adBackgroundColor
        ,blackButtonBackgroundColor,blackButtonTextColor,blackButtonText,blackButtonIcon,textColor,actionBtn
        }=this.props.data
        const button={
            backgroundColor:buttonBackgroundColor,
            buttonTextColor:buttonTextColor,
            text:buttonText,
            bottomFontSize:bottomFontSize
        }
        const blackButton={
            backgroundColor:blackButtonBackgroundColor,
            blackButtonTextColor:blackButtonTextColor,
            text:blackButtonText,
            textColor:blackButtonTextColor,
            icon:blackButtonIcon
        }
        return(
            <Grid sm={12} xs={12} justify={"space-around"} className={'ad'} item container style={
                {backgroundColor:adBackgroundColor,
                 borderColor:borderColor
                }}>
                <Grid sm={12} xs={12} justify='space-between' item container>
                    <Grid item sm={3} xs={3} style={{height:'50px'}}>
                        <BlackButton data={blackButton}/>
                    </Grid>
                    <Grid item sm={6} xs={6}>
                        <p>
                            {title}
                        </p>
                    </Grid>
                </Grid>
                <Grid  sm={10} xs={10} alignItems={"center"} justify='space-between' item container>
                    <Grid style={{color:textColor}} item sm={8} xs={8}>
                        {text}
                    </Grid>
                    <Grid  item sm={4} xs={4} container justify={"center"}>
                        <img style={{width:'50%'}} src={adIcon} alt=""/>
                    </Grid>
                </Grid>
                <Grid alignItems={"center"} justify='space-between' item container xs={10} sm={10}>
                    <Grid container alignItems={"center"} className='clickable' sm={5} xs={5} style={{height:'70px'}}
                        onClick={()=>{
                            window.location.href=actionBtn
                        }}
                    >
                        <Button data={button}/>
                    </Grid>
                    <Grid sm={3} xs={3}/>
                    <Grid sm={4} xs={4}>
                        <p>{adText}</p>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
export default Ad